import type { CancelEnrollment200Result } from './cancelEnrollment200Result';

export type CancelEnrollment200 = {
  /** 취소 일시 */
  cancelledAt: string;
  /**
   * 환불 금액
   * @nullable
   */
  refundAmount?: number | null;
  /** 환불 비율 */
  refundPercentage: number;
  result: CancelEnrollment200Result;
};
